import styled from 'styled-components';

export const StyledVisitTemplateFormTextarea = styled.div`
   height: 144px;
`;
StyledVisitTemplateFormTextarea.displayName = 'StyledVisitTemplateFormTextarea';
